// CarFax / vehicle-history report links keyed by VIN.
// Add a new entry here when a vehicle gets a shareable history report.
// Keys are normalized to uppercase, trimmed VINs.
const REPORTS = {
  // 2014 Subaru Impreza
  JF1GPAL69E8290382: 'https://www.vin-reports-pro.com/share/9ayZTEnr02ISn-GZLvzBB625wpxCo9pgvqeJt4owdEA',
  // 2015 Audi A6 Premium Plus
  WAUDFAFC4FN028318: 'https://www.vin-reports-pro.com/share/C-BNrxgTlG4eHiCPTkSA7qGDHGv1e7zu6pretHOIJWs',
  // 2014 Audi A6
  WAUGFAFC6EN100552: 'https://www.vin-reports-pro.com/share/EvccUeirDyyWDoTDqgkYajI9F8KhPp-EFWJbUIUSHlY',
  // 2018 BMW X1
  WBXHU7C30J5L08251: 'https://www.vin-reports-pro.com/share/r7reARCd2YVse7KYrZDgh4caj8Z_v8mmAy3KleobcSM',
};

// Returns the report URL for a given VIN, or null if none exists.
export function getCarfaxUrl(vin) {
  if (!vin) return null;
  return REPORTS[String(vin).trim().toUpperCase()] || null;
}

export default REPORTS;
